import { Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(private meta: Meta, private title: Title) {}

  updateTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }

  updateMetaTags(tags: MetaDefinition[]) {
    tags.forEach((tag) =>
      this.meta.updateTag({ name: tag.name, content: tag.content })
    );
  }
}
